<template>

    <div :style="{'--sinkbox-plank-scale': framePlankScale, '--actions-offset-x': actionsOffset.x, '--actions-offset-z': actionsOffset.z, '--actions-offset-y': actionsOffset.y,'--sinkbox-pos-0': sinkBoxOffset[0], '--sinkbox-pos-1': sinkBoxOffset[1], '--sinkbox-pos-2': sinkBoxOffset[2], transform:rotation}" :class="['frame', frameSizeClass, {'is-current-group': this.isCurrentGroup, 'has-shadow': this.showShadow, 'is-flipped': this.isFlipped, 'is-open': this.isOpen}, sinkBoxClass]">

        <div class="modules">
            <draggable v-if="group.items" style="transform-style:preserve3d;" class="draggable modrow" :list="group.items" @start="handleDragStart" @end="handleDragEnd" :options="{group:'modules',choosenClass:'is-choosen', dragClass:'is-dragging', animation:0, setData: modifyDragItem, delay:400, group: { name: 'modules', put: canPutModule, pull: canPullModule}}">
            <slot name="module"></slot>
          </draggable>
        </div>
        
        <div class="structure">
            <Module @click.native.prevent.stop="handleFrameClick" :showMeasure="true" class="frame_module open_frame" :moduleID="moduleID" ref="frame" :item="group" :settings="group.settings"/>
        </div>

        <Actions class="actions" remove="true" move="true" flip="true" draghandle="drag-handle-frame" @flip="flipFrame" @moveleft="MOVE_GROUP({old:index, new:-1})" @moveright="MOVE_GROUP({old:index, new:+1})" @remove="REMOVE_GROUP({index})"/>
    
        <button :disabled="!hasSlotsAvailable" @click="handleCloseClick()" class="button cut-icon"><b-icon v-if="isOpen && canSelect" pack="mdi" icon="lock-open"></b-icon><b-icon v-if="!isOpen" pack="mdi" icon="lock"></b-icon></button>

    </div>

</template>

<script>
import Module from '@/components/Module'
import Actions from '@/components/Actions'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import draggable from 'vuedraggable'
export default {

  name: 'OpenFrame',

  props:['group', 'index', 'moduleID', 'angle', 'showShadow', 'canSelect'],

  data: function(){
      
    return {
        observer : null,
        isFlipped: false,
        moduleCount : null
    }
  },

  methods:{

        ...mapMutations(['SET_SLOT_STATUS']),

        ...mapActions(['EDIT_ITEM', 'MOVE_GROUP', 'REMOVE_GROUP', 'playSound']),

        handleFrameClick(){
            if(this.canSelect){
                this.EDIT_ITEM({item:this.group, path:[this.index]});
            }
        },

        handleCloseClick(){
            var message = (this.group.settings.open)? 'Closed frame' : 'Opened frame';
            // this.playSound('http://soundbible.com/mp3/Elevator%20Ding-SoundBible.com-685385892.mp3');
            this.SET_SLOT_STATUS({index: this.index, value: !this.group.settings.open, message});
        },

        handleModuleMove(){
            // console.log('MOVE A MODULE');
        },

        handleDragStart(){
            //this.$store.dispatch('SET_OPTIONS', {showTrash : true});
        },

        handleDragEnd(e){
            //this.$store.dispatch('SET_OPTIONS', {showTrash : false});
            //console.log(e, e.oldIndex, e.newIndex);
            
        },

        canPutModule(to){
        return to.el.children.length < 3 && 'modules';
        },

        canPullModule(to,from){      
        return true;
        //return from.el.children.length > 1 && 'modules';
        },

        rewriteDragImg(icon, event) {  
            var dragIcon = document.createElement('img');
         
            dragIcon.src = icon;
            event.dataTransfer.setDragImage(dragIcon, 40, 20);
        
        },

        canPutModule(to){
    
        return to.el.children.length < 3 && 'modules';
        },

        flipFrame(){
            this.isFlipped = !this.isFlipped;
            let that = this;
            setTimeout(() => {
                that.isFlipped = false;
            }, 4000);
        },

        modifyDragItem (dataTransfer, el,g) {

            // let img = new Image()
            // img.src = 'https://www.google.no/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png'
            // dataTransfer.setDragImage(img, 0, 0)
        },

  },

  computed:{

    ...mapGetters(['selectedItem', 'stageSettings']),


    factor(){        
        return this.stageSettings.stage_scale;
    },

    size(){
        
        if(this.group.hasOwnProperty('items')){
            return this.group.items.length;
        }else{
            return 1;
        }
    },

    frameSizeClass(){
        return 'is-frame-size-' + this.size;
    },

    hasSlotsAvailable(){
        return this.group.items.length < this.group.frame.slots;
    },

    isOpen(){
        return this.group.settings.open && this.hasSlotsAvailable;
    },

    rotation(){
        switch(this.angle){
            case 'side': 
                return 'rotateY(-90deg)';
            case 'back': 
                return 'rotateY(-180deg)';
            case 'front': 
                return 'rotateY(0deg)';
        }
    },

    isCurrentGroup(){
        return this.group === this.selectedItem;
    },

    sinkBoxClass(){
    
    if(this.sinkPos > -1){
        return 'has-sinkbox-at-' + this.sinkPos;
    }

    if(this.gasPos > -1){
        return 'has-sinkbox-last'
    }

    return 'has-no-sinkbox';
    },

    actionsOffset(){
        return {y: 2 * this.factor + 'px', x:  this.group.items.length-3.5 * this.factor + 'px', z: 10 * this.factor + 'px'}
    },

    sinkBoxOffset(){

        return [
            `${Math.ceil(0.25 * this.factor)}em`,
            `${Math.ceil(1.3 * this.factor)}em`,
            `${Math.ceil(0.25 * this.factor)}em`,
            `${Math.ceil(0.4 * this.factor)}em`
        ]

        this.$forceUpdate();
    },

    sinkPos(){
        if(!this.group.items) return;
        return this.group.items.map(function(x) {return x.id; }).lastIndexOf('kitchen_sink');
    },

    gasPos(){
        if(!this.group.items) return;
        var index1 = this.group.items.map(function(x) {return x.id; }).lastIndexOf('gas_grill');
        var index2 = this.group.items.map(function(x) {return x.id; }).lastIndexOf('cooker_hob');
        
        return Math.max(index1, index2);
    },

    framePlankScale(){
        return `${Math.ceil(0.6 * this.factor)}em`;
    }

  },

  mounted(){

    var self = this;

    //this.moduleCount = this.size;

    //Create the observer (and what to do on changes...)
    // this.observer = new MutationObserver(function(mutations) {        
    //    var frameSize = self.$el.querySelectorAll('.module.top').length;
    //     // self.$refs.frame.setSize(frameSize);
    //     //this.group.settings.frame_size = frameSize;
    // }.bind(this));

    //Setup the observer
    // this.observer.observe(
    //   self.$el.querySelector('.modules'),
    //   { attributes: true, childList: true, characterData: true, subtree: true }
    // );

    },

   beforeDestroy: function() {
    // Clean up observer
    // this.observer.disconnect();
  },

  components:{
      Module,
      draggable,
      Actions
  },

  watch:{
    size: {

        handler(newSize, oldSize){      
            if(newSize === 0){
                this.REMOVE_GROUP({index:this.index, noHistory:true});
            }
        }
        
    },
    group: {
        handler(newGroup, oldGroup){            
            if(newGroup.hasOwnProperty('items')){
                this.group.settings.frame_size = this.group.items.length;                    
            }
        },
        deep: true
    }
  }

}
</script>


<style>
    :root{
        --sinkpos_0: 1em; 
    }
    .sinkbox{
        z-index:9;
    }

    .frame_module .teak-bottom .face.tp .photon-shader{
        background-size: var(--sinkbox-plank-scale) 100% !important;
    }

    .has-sinkbox-at-0 .sinkbox{
        left: var(--sinkbox-pos-0) !important;
    }

    .has-sinkbox-at-1 .sinkbox{
        left: var(--sinkbox-pos-1) !important;
    }

    .has-sinkbox-at-2 .sinkbox, .has-sinkbox-last .sinkbox{
        left:auto !important;
        right: var(--sinkbox-pos-2) !important;
    }
 
    .has-no-sinkbox .sinkbox{
        display: none!important;
        left:0!important;
    }


.open_frame .measure.height{
    top:-44.5%!important;
    height:144%!important;
}

</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

.actions{
    transform: translateX(var(--actions-offset-x)) translateZ(var(--actions-offset-z)) translateY(-100px) ;
    display: none;
    position: absolute;
    margin-left:-40px;
}


.frame{
    display:inline-block;
    transform-style: preserve-3d;
    text-align:center;
    position: relative;
    vertical-align:bottom;
    /* //transform:rotateX(-85deg); */
}

.frame.has-shadow::after{
    display:block;
    content:'';
    left:0px;
    right:0px;
    bottom:0;
    top:auto;
    height:200px;
    position: absolute;
    transform:rotateX(90deg) translateZ(-100px) translateY(100px);
    background:linear-gradient(transparent 0%, rgba(0,0,0,0.03) 50%, transparent 70%),radial-gradient(ellipse at top left, rgba(0,0,0,0.06) 0%,  transparent 70%,transparent 100%), 
    radial-gradient(ellipse at top right, rgba(0,0,0,0.3) 0%,  transparent 70%,transparent 100%);
    pointer-events:none;
}

.show-gaps .frame{
    margin:0 15px;
}

.show-measure .frame{
    margin:0 50px;
}

.frame.is-flipped .structure, .frame.is-flipped .modules{
    transform:rotateY(180deg);
    transform-style: preserve-3d;
}

.draggable{
    // line-height: 0;
    transform-style: preserve-3d!important;
  }

.modrow{
    transform-style: preserve-3d!important;
    // display: flex;
    // flex-direction: row;
    // flex-wrap: nowrap;
    // align-items: flex-end;
}

.frame .cut-icon{
    border-radius:0;
    border:0;
    position: absolute;
    bottom:50%;
    border-radius:100%;
    outline:none;
    color:$black;
    right:0;
    transform: translateZ(var(--actions-offset-z))  translateX(40px) translateY(var(--actions-offset-y));
}

.frame.is-open .cut-icon{
    color:hsl(171, 100%, 41%);
}


.frame .cut-icon:focus {
    outline:0;
}


.frame:not(:last-of-type) .cut-icon{
    display: none;
}

.is-current-group .actions{
    display: inline-block;
}

.modules{
    z-index:3;
    position:relative;
    transform-style: preserve-3d;    
    transition:300ms;
}

.structure{
    position:relative;
    z-index:1;
    transform-style: preserve-3d;  
    transition:300ms;  
}

.structure .frame_module{ 
    display:block;
}

/* .frame.is-current-group{
    transform:translateY(-10px);
    
} */


</style>
